import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';

@Component({
  selector: 'app-section3-1',
  templateUrl: './section3-1.component.html',
  styleUrls: ['./section3-1.component.css'],
  providers: [LogisticsService]
})
export class Section31Component implements OnInit {
  @Input("month") month;
  @Input("role") role;
  currentDate:any;
  shipments:any;
  cashCollected:any;
  pending:any;
  cancelled:any;
  currency:any;

  constructor(private db:AngularFireDatabase, private ls:LogisticsService) {
    this.currentDate = new Date();
   }

  ngOnInit() {
    //console.log("month",this.month);
    if(this.role == "super admin")
    {
      this.getMonthlyInsight(this.month);
    }
    else
    {
      this.getMonthlyAdminInsight(this.month);
    }
    this.getCurrency();
    
  }
  
  getCurrency()
  {
    this.ls.currency.subscribe(currency => {
      this.currency = currency; 
    });
  }
  getMonthlyInsight(month)
  {
    var year = this.currentDate.getFullYear();
    this.db.list("shipments").snapshotChanges().subscribe(item=>{
      this.shipments = 0;
      this.cashCollected = 0;
      this.pending = 0;
      this.cancelled = 0;
        item.forEach(element =>{
          if(element.payload.child("source").child("date").child("year").val() == year || element.payload.child("destination").child("date").child("year").val() == year)
          {
            if(element.payload.child("source").child("date").child("month").val() == month || element.payload.child("destination").child("date").child("month").val() == month)
            {
              this.shipments++;
              if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0)
              {
                this.cashCollected = this.cashCollected + element.payload.child("cashCollected").val();
              }
              if(element.payload.child("status").val() == 6 || element.payload.child("status").val() == 7)
              {
                this.pending++;
              }
              if(element.payload.child("status").val() == 2 || element.payload.child("status").val() == 10)
              {
                this.cancelled++;
              }
            }
          }
        });
        //console.log("super admin",this.shipments,this.cashCollected);
      });
  }
  getMonthlyAdminInsight(month)
  {
    var year = this.currentDate.getFullYear();
    this.db.list("shipments").snapshotChanges().subscribe(item=>{
      this.shipments = 0;
      this.cashCollected = 0;
      this.pending = 0;
      this.cancelled = 0;
        item.forEach(element =>{
          if(element.payload.child("branch").val() == localStorage.getItem("branch"))
          {
            if(element.payload.child("source").child("date").child("year").val() == year || element.payload.child("destination").child("date").child("year").val() == year)
            {
              if(element.payload.child("source").child("date").child("month").val() == month || element.payload.child("destination").child("date").child("month").val() == month)
              {
                //console.log("admin shipment",element.key,element.payload.child("branch").val());
                this.shipments++;
                if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0)
                {
                  //console.log("admin cashCollected",element.key,element.payload.child("branch").val(), element.payload.child("cashCollected").val());
                  this.cashCollected = this.cashCollected + element.payload.child("cashCollected").val();
                }
                if(element.payload.child("status").val() == 6 || element.payload.child("status").val() == 7)
                {
                  this.pending++;
                }
                if(element.payload.child("status").val() == 2 || element.payload.child("status").val() == 10)
                {
                  this.cancelled++;
                }
              }
            } 
          }
        });
        //console.log("admin",this.shipments,this.cashCollected);
      });
  }
  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    if (changes['month']) {
      //console.log("month",this.month);
      if(this.role == "super admin")
      {
        this.getMonthlyInsight(this.month);
      }
      else
      {
        this.getMonthlyAdminInsight(this.month);
      }
    }
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/section3-1/section3-1.component.ts